import { observer } from "mobx-react-lite";
import { Button, Icon, Text } from "@blueprintjs/core";
import default_formats from "../config/default_formats";

let AVAILABLE_SIZES = default_formats;

const useMagicResize = false;
const PRINT_FORMAT_BACKGROUND_NAME = "print-format-background";

export const ResizePanel = observer(({ store }) => {
  if (window.CUSTOM_SIZES) {
    AVAILABLE_SIZES = CUSTOM_SIZES;
  }
  return (
    <div>
      {AVAILABLE_SIZES.map(({ label, width, height, background }, i) => (
        <Button
          alignText="left"
          minimal="true"
          key={i}
          style={{ width: "100%", marginBottom: "20px" }}
          onClick={() => {
            setBackground(store, { label, width, height, background });
          }}
        >
          <Icon style={{ marginRight: "1.1rem" }} icon="airplane"></Icon>
          <Text style={{ fontSize: "1.1rem" }} tagName="span" ellipsize="false">
            {label}
            <span style={{ fontSize: "0.8rem", float: "right" }}>
              {width}x{height}
            </span>
          </Text>
        </Button>
      ))}
    </div>
  );
});

export const setBackground = (store, format) => {
  const { label, width, height, background } = format;

  store.setSize(parseFloat(width), parseFloat(height), useMagicResize);
  store.activePage.set({ bleed: 0 });

  //remove old backgrounds
  const elementsToRemove = store.activePage.children.map((child) => {
    if (child.name === PRINT_FORMAT_BACKGROUND_NAME) {
      return child.id;
    }
  });
  store.deleteElements(elementsToRemove);
  if (background) {
    //add new background
    const element = store.activePage.addElement({
      name: PRINT_FORMAT_BACKGROUND_NAME,
      type: "image",
      src: background,
      selectable: false,
      alwaysOnTop: false,
      showInExport: false,
      x: 0,
      y: 0,
      width: store.width,
      height: store.height,
    });
    element.moveBottom();

    // store.activePage.set({ background: "rgba(0,0,0,0)" });
  }

  store.activePage.set({ background: "white" });
};
